











































import {defineComponent, PropType} from "@vue/composition-api"
import HeadingAtom from "@/shared/components/atoms/HeadingAtom.vue";
import {IPortalSubtopic} from "@/apps/PortalTopicWidget/models/portal-topic-widget-state";

export default defineComponent({
  name: "PortalSubtopic",
  components: {
    HeadingAtom
  },
  props: {
    item: {type: Object as PropType<IPortalSubtopic>}
  }
})
